import React from "react";
import { Route, Switch } from "react-router-dom";
import { DigitalReturnsList, DigitalReturnsView } from "./DigitalReturns";

export default () => {
    return {
        routes: [
            {
                path: "/digital-returns",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}`}
                            exact
                            component={DigitalReturnsList}
                        />
                        <Route path={`${match.url}/:id`} exact>
                            {(props) => <DigitalReturnsView {...props} />}
                        </Route>
                    </Switch>
                ),
            },
        ],
    };
};
